import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from './Field'
import styles from './Text.module.scss'

const Text = React.forwardRef(({ inline, className, disablePasswordAutoComplete, ...rest }, ref) => {
	const fieldProps = {
		...rest,
		...disablePasswordAutoComplete && rest.type === 'password' && { // this is a hack to turn off chrome autocomplete and 'save password' prompt
			autoComplete: 'off',
			readOnly: true,
			onFocus: e => {
				e.target.removeAttribute('readonly')
				e.target.setAttribute('autocomplete', 'new-password')
				if(rest.onFocus) {
					rest.onFocus(e)
				}
			}
		},
		innerRef: ref
	}
	return (
		<div className={classNames(styles.root, {
			inline: inline,
			[className]: className,
			[styles.hidden]: rest.hidden,
			[styles.readOnly]: rest.readOnly
		})}>
			<TextField {...fieldProps}/>
		</div>
	)
})

Text.propTypes = {
	field: PropTypes.string,
	noForm: PropTypes.bool,
	type: PropTypes.oneOf([
		'text',
		'password'
	]),
	label: PropTypes.string,
	inline: PropTypes.bool,
	pwdVisibilityBtn: PropTypes.bool,
	disablePasswordAutoComplete: PropTypes.bool
}

Text.defaultProps = {
	type: 'text'
}

export default Text
